import React, { useState } from 'react'

import toast from 'react-hot-toast'
import { useLocation, useNavigate } from 'react-router-dom'

import DescriptionSection from './DescriptionSection'
import QuestionsSection from './QuestionsSection'
import { SectionSubtitle, BackButton, Button } from '../../components'
import FormHeader from '../../components/forms/formHeader/FormHeader'
import { useStudents, useUser } from '../../context'

import {
  ContainerInitialForm,
  Form,
  FormContainer,
  InitialFormContent,
} from './styles'

const InitialForm = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const userId = location.state?.userId
  const { user } = useUser()
  const { saveFormAnswers } = useStudents()

  const userUID = userId ?? user?.uid

  const sendForm = async () => {
    try {
      await saveFormAnswers(userUID, formAnswers)

      toast.success('Formulario guardado correctamente')
      navigate('/perfil')
    } catch (error) {
      toast.error(error as string)
    }
  }

  const [formAnswers, setFormAnswers] = useState<Record<string, string>>({})

  const isFormIncomplete = !['1', '2', '3', '4', '5', '6', '7'].every(
    (id) => formAnswers[id] && formAnswers[id].trim() !== '',
  )

  return (
    <ContainerInitialForm>
      {!user && <FormHeader />}

      <InitialFormContent $isLogged={user ? true : false}>
        <BackButton />
        <DescriptionSection />
        <FormContainer>
          <Form>
            <SectionSubtitle
              children="Responde las siguientes 7 consignas:"
              textAlign="left"
              fontSize={18}
              fontWeight={500}
              lineHeight={25}
              className="initial-form-title"
            />

            <QuestionsSection
              formAnswers={formAnswers}
              setFormAnswers={setFormAnswers}
            />

            <SectionSubtitle
              fontSize={18}
              fontWeight={500}
              children="¡Gracias por llegar hasta aquí!"
            />

            <Button
              onClick={sendForm}
              label="Guardar respuesta"
              className="dark-grey button-save"
              disabled={isFormIncomplete}
            />
          </Form>
        </FormContainer>
      </InitialFormContent>
    </ContainerInitialForm>
  )
}

export default InitialForm
